import React from "react";
import "./FluxopayRiskPosition.css";

const money = value =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const date = value => {
  if (!value) return null;

  return new Date(value).toLocaleDateString("pt-BR");
};

export default function FluxopayRiskPosition({ account }) {
  if (!account || account.status !== "active") {
    return null;
  }

  const hasDebt = Number(account.negativeBalance || 0) > 0;
  const hasReserve = Boolean(
    account.reserveActive
    );

  return (
    <section
      className={[
        "fxpay-risk-position",
        hasDebt
          ? "is-debt"
          : hasReserve
            ? "is-reserve"
            : "is-normal",
      ].join(" ")}
    >
      <header className="fxpay-risk-position__header">
        <div>
          <small>POSIÇÃO PARA REPASSES</small>

          <h3>
            {hasDebt
              ? "Saldo temporariamente bloqueado"
              : hasReserve
                ? "Reserva preventiva ativa"
                : "Saldo disponível para transferência"}
          </h3>

          <p>
            {hasDebt
              ? "Existem estornos ainda não compensados. Novos recebimentos serão usados para regularizar esse valor antes da liberação de repasses."
              : hasReserve
                ? "Parte do saldo permanece protegida durante o período inicial da operação para cobrir eventuais estornos."
                : "A conta não possui saldo devedor nem retenção preventiva ativa."}
          </p>
        </div>

        <span className="fxpay-risk-position__status">
          {hasDebt
            ? "Repasse bloqueado"
            : hasReserve
              ? "Proteção ativa"
              : "Operação normal"}
        </span>
      </header>

      <div className="fxpay-risk-position__values">
        <article>
          <span>Saldo no Asaas</span>
          <strong>
            {money(account.providerAvailableBalance)}
          </strong>
          <small>Valor informado pelo provedor</small>
        </article>

        <article
          className={
            hasReserve
              ? "is-warning"
              : ""
          }
        >
          <span>Reserva para estornos</span>
          <strong>
            {money(account.refundReserve)}
          </strong>
          <small>
            {hasReserve
              ? `${Number(
                  account.reservePercentage || 0
                ).toLocaleString("pt-BR", {
                  maximumFractionDigits: 4,
                })}%`
              : "Sem reserva ativa"}
          </small>
        </article>

        <article
          className={
            hasDebt
              ? "is-danger"
              : ""
          }
        >
          <span>Saldo devedor</span>
          <strong>
            {money(account.negativeBalance)}
          </strong>
          <small>
            {hasDebt
              ? "Será compensado pelos próximos recebimentos"
              : "Nenhum estorno pendente"}
          </small>
        </article>

        <article className="is-primary">
          <span>Liberado para repasse</span>
          <strong>
            {money(account.availableBalance)}
          </strong>
          <small>
            Já desconta reserva, dívida e repasses pendentes
          </small>
        </article>
      </div>

      {(hasReserve || Number(account.reservedPayout || 0) > 0) && (
        <footer className="fxpay-risk-position__footer">
          {hasReserve && (
            <span>
              Reserva preventiva
              {date(account.reserveUntil)
                ? ` vigente até ${date(account.reserveUntil)}`
                : " sem data de encerramento"}
            </span>
          )}

          {Number(account.reservedPayout || 0) > 0 && (
            <span>
              {money(account.reservedPayout)} já comprometidos
              com repasses em processamento
            </span>
          )}
        </footer>
      )}
    </section>
  );
}